<template>
    <div class="weilan">
        <!-- 我是围栏设置 -->
        <div>
            <el-button type="text" class="addWeilan" @click="addClick" v-if="addShow">添加围栏</el-button>
        </div>
        <div class="weilanVale" v-if="addShow" >
            <div class="Table-Bottom" >
                <el-table
                        :header-cell-style="{background:'#fff',color:'#000', height:'40px', }"
                        ref="multipleTable"
                        :data="tableData"
                        :cell-style="{'text-align':'center'}"
                        tooltip-effect="dark"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                        prop="name"
                        label="名称"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="longitude"
                        label="经度"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="latitude"
                        label="维度"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="radius"
                        label="半径"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="进出围栏提醒"
                        show-overflow-tooltip>
                        <template #default="scope">
                            {{scope.row.autoNotify? '是':'否' }}                            
                        </template> 
                      
                    </el-table-column>
                    
                    <el-table-column
                        prop="address"
                        label="操作"
                        show-overflow-tooltip>
                    <template #default="scope">
                        <span @click="updateClick(scope.row)" class="update-title">查看</span>
                        <span @click="deleteClick(scope.row)" class="delete-title">删除</span>
                    </template>
                    </el-table-column>
                </el-table>
        </div>
        </div>
        <div class="addweilan" v-if="!addShow">
            <div class="leftweilan">
                <!-- mac1 -->
                <el-form label-width="70" >
                     <el-form-item label="名称:">
                        <el-input v-model="formData.name" ></el-input>
                    </el-form-item>
          
                <el-form-item :label='`mac${index+1}:`' v-for="(item,index) in listBox" prop="username" >
                    <el-input v-model="item.value" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="提醒：" >
                <el-radio-group v-model="formData.radio" >
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <span>请通过地图标注围栏中心点坐标经、纬度， 并选择合适的围栏半径。</span>
                    </el-form-item>
                      <el-form-item label="经度:">
                        <el-input v-model="formData.lng" ></el-input>
                    </el-form-item>
                    <el-form-item label="维度:">
                        <el-input v-model="formData.lat" ></el-input>
                    </el-form-item>
                    <el-form-item label="半径:" prop="region">
                        <el-select placeholder="" v-model="zhongduanRadius" @change="banjingClick">
                            <el-option :label="item.name" :value="item.value" v-for="item in banjing"></el-option>
                        </el-select>
                        </el-form-item>
                    </el-form>
            </div>
                <div class="rightweilan">
                    <div class="seatherText">
                        地址：<input type="text" class="sousuokuang" id="tipinput" v-model="dizhi" >
                        <el-button type="primary" @click="onSubmit"  >立即创建</el-button>
                <el-button type="primary" @click="onReturn">返回</el-button>
                    </div>
                    <div class="ditu" >
                        <Mapview  
                        :status="status" 
                        :zhongduanItem="zhongduanItem"
                        :zhongduanRadius="zhongduanRadius"
                        @zhongDuanPosition="zhongDuanPosition"
                        ></Mapview>
                    </div>
                </div>
               
            </div>
    </div>
</template>

<script>
import Mapview from "@/components/MapContainer.vue"
import { circleFind,circleAdd,circleDelete,circleUpdate } from '@/assets/api/zhongduan.js'

export default {
    components: {
        Mapview
    },
    data() {
        return {
            status: null,
            banjing: [
                    {
                    name: '300',
                    value: 300
                    },
                    {
                    name: '400',
                    value: 400
                    },
                    {
                    name: '500',
                    value: 500
                    },
            ],
            listBox: [
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },
                {
                    value: '',
                },

            ],
            tableData:[
            ],
            formData: {
                name: '',
                radio: 0,
                lng: '',
                lat: '',
            },
            zhongduanRadius: 300,
            ObjAddress: {},
            addShow: true,
            dizhi: '',
            zhongduanItem: {}
        };
    },
    created() {
        this.status = '4'
    },
    mounted() {
        this.GetcircleFind()
    },
    watch: {
        
    },
    methods: {
        onReturn () {
            this.addShow = true
            this.zhongduanItem = {}
        },
        onSubmit () {
            console.log(this.zhongduanItem, );
            if ( JSON.stringify(this.zhongduanItem) == '{}' ) {
                this.postCircleAdd()   
                console.log('新增'); 
            } else {
                this.postCircleUpdate()
                console.log('修改');
            }
        },
        postCircleAdd () {
            let params = {
                addr:this.ObjAddress.name,
                autoNotify:this.formData.radio==0? true:false,
                latitude:this.formData.lat,
                longitude:this.formData.lng,
                macAddress:'11111',
                name: this.formData.name,
                radius: this.zhongduanRadius,
                circleMac1: this.listBox[0].value,
                circleMac2: this.listBox[1].value,
                circleMac3: this.listBox[2].value,
                circleMac4: this.listBox[3].value,
                circleMac5: this.listBox[4].value,
                circleMac6: this.listBox[5].value,
                circleMac7: this.listBox[6].value,
                circleMac8: this.listBox[7].value,
                circleMac9: this.listBox[8].value,
                circleMac10: this.listBox[9].value,
            }
                
            circleAdd(params,this.$route.query.iemi).then((res)=> {
                console.log(res);
                this.GetcircleFind()
                this.addShow = true
                this.listBox.forEach((item)=> {
                    item.value = ''
                })
            })
        },
        postCircleUpdate () {
            let params = {
                addr:this.ObjAddress.name,
                autoNotify:this.formData.radio==0? true:false,
                latitude:this.formData.lat,
                longitude:this.formData.lng,
                macAddress:'11111',
                name: this.formData.name,
                radius: this.zhongduanRadius,
                circleMac1: this.listBox[0].value,
                circleMac2: this.listBox[1].value,
                circleMac3: this.listBox[2].value,
                circleMac4: this.listBox[3].value,
                circleMac5: this.listBox[4].value,
                circleMac6: this.listBox[5].value,
                circleMac7: this.listBox[6].value,
                circleMac8: this.listBox[7].value,
                circleMac9: this.listBox[8].value,
                circleMac10: this.listBox[9].value,
            }
            circleUpdate(params,this.zhongduanItem.id ).then((res)=> {
                console.log(res);
                this.GetcircleFind()
                this.addShow = true
                this.listBox.forEach((item)=> {
                    item.value = ''
                })
            })
        },
        zhongDuanPosition (value) {
            this.formData.lng = value.location.lng
            this.formData.lat = value.location.lat
            this.ObjAddress = value
        },
        GetcircleFind () {
            let params = {
                imei: this.$route.query.iemi
            }
            circleFind(params).then((res)=> {
                console.log(res,'围栏查询');
                this.tableData = res.data.data
            }).catch((err)=> {
                console.log(err);
            })
        },
        deleteClick (item) {
            let params = {
                id: item.id
            }
            circleDelete(params).then((res)=> {
                console.log(res,'删除');
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
                this.GetcircleFind()
            }).catch((err)=> {
                console.log(err);
            })
        },
        addClick () {
            this.addShow = false
            this.formData = {
                name: '',
                radio: 0,
                lng: '',
                lat: '',
            }
            this.dizhi = ''
            this.zhongduanItem = {}
        },
        updateClick (item) {
            this.addShow = false
            this.formData.name = item.name
            this.formData.zhongduanRadius = item.radius
            this.formData.lng = item.longitude
            this.formData.lat = item.latitude
            this.formData.radio = item.autoNotify? 0:1
            this.zhongduanItem = item
            this.dizhi = item.addr
            this.listBox[0].value = item.circleMac1
            this.listBox[1].value = item.circleMac2
            this.listBox[2].value = item.circleMac3
            this.listBox[3].value = item.circleMac4
            this.listBox[4].value = item.circleMac5
            this.listBox[5].value = item.circleMac6
            this.listBox[6].value = item.circleMac7
            this.listBox[7].value = item.circleMac8
            this.listBox[8].value = item.circleMac9
            this.listBox[9].value = item.circleMac10
        },
        banjingClick () {
            console.log(this.zhongduanRadius);
        },
    },
};
</script>

<style scoped lang="scss">

    .weilan{    
        // width: 320px;
        // border: 1px solid #eee;
        margin-top: 15px;
       /deep/{
        .el-select--small .el-select__wrapper{
            width: 220px !important;
        }
       }
        .addWeilan{
            font-size: 16px;
        }
        .weilanVale{
            height: 100px;
            width: 750px;
            // background-color: pink;
        .Table-Bottom {
            width: 700px; /*no*/
            border: 1px solid  #ccc;
            margin-top: 15px;   
        
        /deep/ {


            .el-input {
                width: 160px;
            }
            .el-table th.el-table__cell>.cell {
                text-align: center;
                font-size: 15px;
            }
        }
    }
        }
        .addweilan{
            display: flex;
            // padding-top: 10px;
            
        }
        .leftweilan{
            height: 300px;
            // width: 400px;
            // background-color: skyblue;
            /deep/ {
                .el-input--small{
                    width: 60%;
                    height: 25px;

                }
                .el-form-item--small .el-form-item__label{
                    font-size: 16px;
                }

                
                
            }
                

        }
        .rightweilan{
            height: 600px;
            width: 800px;
            // background-color: green;
         

        }
        .seatherText{
            .sousuokuang{
                border: 1px #ccc solid;
                width: 30%;
                margin-right: 10px;

            }
        }
        .ditu{
            margin-top: 10px;
            width: 100%;
            height: 100%;
        }
        .delete-title {
        color: red;
        cursor: pointer;
        margin-left: 5px;
    }
    .update-title {
        color: #61affe;
        cursor: pointer;
    }
    }
</style>
